import React, { Component } from "react";
import { connect } from "react-redux";
import { Card } from "components/Card/Card.jsx";
import SimpleReactValidator from "simple-react-validator";
import { withRouter } from "react-router-dom";
import { MdNavigateNext, } from 'react-icons/md';
import { Grid, Row, Col } from "react-bootstrap";
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import BrandLogo from "./BrandLogo";


class SelectBrand extends Component {
    constructor(props) {
        super(props);
        this.validatorBrand = new SimpleReactValidator();
        this.state = {
            brand: {
                title: "",
                short_code: "",
                brand_status: "0"
            },
            brands: [
                {
                    logo: "",
                    name: "Placeholder",
                    isSelected: false
                }
            ],
            requiredTagFlag: false,
            submitted: false,
            allowedFormatsStringMime: "image/jpeg, image/png",
            allowedFormatsStringExt: "jpg, png"
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.brands !== prevProps.brands &&
            this.props.currentStep === 1
        ) {
            if (this.props.brands.length === 1 && this.props.brands[0].isSelected) {
                this.onBrandSubmit();
            }
        }

        if (
            this.props.brands !== prevProps.brands &&
            this.props.currentStep === 1 && this.props.movedFromOpenCart
        ) {
            if (this.props.brands.length > 0 && this.props.selectedBrand.isSelected) {
                this.onBrandSubmit();
            }
        }
    }

    selectLogo = (listType, arrList, index) => {
        this.props.selectedLogo(
            listType, arrList, index
        );
        setTimeout(() => {
            this.onBrandSubmit();
        }, 500);
    }

    onBrandSubmit = e => {
        const { brand_id } = this.props.selectedBrand;

        this.props.getOrderSteps(brand_id).then(
            response => {
                if (response.result.is_tag_layout_required === 1) {
                    if (response.result.tag_layout_step_order === 1) {
                        this.props
                            .onBrandSelection({
                                orderSteps: response.result.order_steps,
                                brand_definition_order_steps: response.result.brand_definition_order_steps,
                                dataDefinition: response.result.data_definition,
                                action: "get_tag_layouts",
                                nextStepNum: 3,
                                prevStepNum: 1
                            })
                            .then(res => {
                                this.props.goToStep(2);
                            });
                    } else if (response.result.tag_layout_step_order === 2) {
                        this.props
                            .onBrandSelection({
                                orderSteps: response.result.order_steps,
                                brand_definition_order_steps: response.result.brand_definition_order_steps,
                                dataDefinition: response.result.data_definition,
                                action: "get_po_lookup",
                                nextStepNum: 2,
                                prevStepNum: 1
                            })
                            .then(res => {
                                this.props.goToStep(3);
                            });
                    }
                } else {
                    this.props
                        .onBrandSelection({
                            orderSteps: response.result.order_steps,
                            brand_definition_order_steps: response.result.brand_definition_order_steps,
                            dataDefinition: response.result.data_definition,
                            action: "get_po_lookup",
                            nextStepNum: 4,
                            prevStepNum: 1
                        })
                        .then(res => {
                            this.props.goToStep(3);
                        });
                }
            },
            error => {
                return error;
            }
        );
    };

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3
                                                        style={{
                                                            textAlign: "center",
                                                            fontWeight: "500"
                                                        }}
                                                    >
                                                        Create Order
                                                    </h3>
                                                    <form
                                                        onSubmit={
                                                            this.onBrandSubmit
                                                        }
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <h4>
                                                                    Select Brand
                                                                </h4>
                                                                <div className="brandsGrid gridElem grid_6">
                                                                    {this.props.brands.map(
                                                                        (
                                                                            brand,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <div
                                                                                    onClick={() =>
                                                                                        this.selectLogo(
                                                                                            "brands",
                                                                                            this
                                                                                                .props
                                                                                                .brands,
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    className={
                                                                                        brand.isSelected
                                                                                            ? "brandInfo selectedBrand"
                                                                                            : "brandInfo"
                                                                                    }
                                                                                >
                                                                                    <BrandLogo
                                                                                        brand={
                                                                                            brand
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="stepsNav mt-lg">
                                                            {
                                                                this.props.selectedBrand &&
                                                                <div className="text-center">
                                                                    <button type="button" onClick={() => this.onBrandSubmit()} className="stepNav next" ><MdNavigateNext /></button>
                                                                    <span className="display_ib mt-xs">Next</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </form>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getOrderSteps: id => {
            return dispatch(createOrderActions.getOrderSteps(id));
        }
    };
};

function mapStateToProps(state) {
    const { brands } = state.brandReducer;
    return {
        brandsData: brands
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SelectBrand)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/SelectBrand.jsx